import React from 'react'
import About from './About'
import Services from './Services'
import Recommend from './Recommend'
import Testimonials from './Testimonials'

const Home = () => {
  return (
    <div>
        <About />
        <Services />
        <Recommend />
        <Testimonials />
    </div>
  )
}

export default Home;